var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DropdownSelectValue',{attrs:{"placeholder":_vm.$t('CalcMethodSelect:Select.Placeholder'),"label":_vm.$t('CalcMethodSelect:Select.Label'),"options":_vm.calculationMethods,"disabled":_vm.disabled,"locked":_vm.locked},model:{value:(_vm.calcMethod),callback:function ($$v) {_vm.calcMethod=$$v},expression:"calcMethod"}})
}
var staticRenderFns = []

export { render, staticRenderFns }